// eLodge domain — cloud lodgement fleet + SLA + credentials.
import { API } from './_client';

export const elodge = {
  supported: () => API.get('/elodge/supported').then((r) => r.data),
  credsStatus: () => API.get('/elodge/credentials').then((r) => r.data),
  saveCreds: (username, password) => API.put('/elodge/credentials', { username, password }).then((r) => r.data),
  removeCreds: () => API.delete('/elodge/credentials').then((r) => r.data),
  enqueue: (matter_ref, subclass, payload, dry_run = true) =>
    API.post('/elodge/jobs', { matter_ref, subclass, payload, dry_run }).then((r) => r.data),
  jobs: (matter_ref) => API.get('/elodge/jobs', { params: { matter_ref } }).then((r) => r.data),
  job: (id) => API.get(`/elodge/jobs/${id}`).then((r) => r.data),
  resume: (id, token, human_input) =>
    API.post(`/elodge/jobs/${id}/resume`, { token, human_input }).then((r) => r.data),
  cancel: (id) => API.delete(`/elodge/jobs/${id}`).then((r) => r.data),
  fleet: () => API.get('/elodge/fleet').then((r) => r.data),
  reap: () => API.post('/elodge/fleet/reap').then((r) => r.data),
  cancelOrg: (org_id, reason) =>
    API.post('/elodge/fleet/cancel-org', { org_id, reason }).then((r) => r.data),
  alerts: {
    get: () => API.get('/elodge/fleet/alerts/config').then((r) => r.data),
    save: (patch) => API.post('/elodge/fleet/alerts/config', patch).then((r) => r.data),
    test: () => API.post('/elodge/fleet/alerts/test').then((r) => r.data),
  },
  sla: {
    get: () => API.get('/elodge/fleet/sla').then((r) => r.data),
    save: (targets) => API.post('/elodge/fleet/sla', { targets }).then((r) => r.data),
    scan: () => API.post('/elodge/fleet/sla/scan').then((r) => r.data),
    trend: (days = 90) => API.get('/elodge/fleet/sla/trend', { params: { days } }).then((r) => r.data),
  },
};
